import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AttachAvailabilitySessionPhotoMutationVariables = Types.Exact<{
  input: Types.AttachAvailabilityPhotoInput;
}>;


export type AttachAvailabilitySessionPhotoMutation = { __typename?: 'Mutation', attachAvailabilitySessionPhoto: { __typename?: 'AvailabilitySessionPayload', attachedPhotoId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AvailabilitySessionPayloadFragment = { __typename?: 'AvailabilitySessionPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null };

export type RemoveItemAvailabilityPhotoMutationVariables = Types.Exact<{
  input: Types.RemoveItemAvailabilityPhotoInput;
}>;


export type RemoveItemAvailabilityPhotoMutation = { __typename?: 'Mutation', removeItemAvailabilityPhoto: { __typename?: 'ItemAvailabilityPhotoPayload', photos?: Array<{ __typename?: 'ItemAvailabilityPhotoData', photoId: string, photoUrl: string, recordedAt: Types.TDateISO, isPrimary: boolean }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetItemAvailabilityPhotoPrimaryMutationVariables = Types.Exact<{
  input: Types.SetItemAvailabilityPhotoPrimaryInput;
}>;


export type SetItemAvailabilityPhotoPrimaryMutation = { __typename?: 'Mutation', setItemAvailabilityPhotoPrimary: { __typename?: 'ItemAvailabilityPhotoPayload', photos?: Array<{ __typename?: 'ItemAvailabilityPhotoData', photoId: string, photoUrl: string, recordedAt: Types.TDateISO, isPrimary: boolean }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export const AvailabilitySessionPayloadFragmentDoc = new TypedDocumentString(`
    fragment AvailabilitySessionPayload on AvailabilitySessionPayload {
  errors {
    code
    message
  }
}
    `, {"fragmentName":"AvailabilitySessionPayload"});
export const AttachAvailabilitySessionPhotoDocument = new TypedDocumentString(`
    mutation AttachAvailabilitySessionPhoto($input: AttachAvailabilityPhotoInput!) {
  attachAvailabilitySessionPhoto(input: $input) {
    ...AvailabilitySessionPayload
    attachedPhotoId
  }
}
    fragment AvailabilitySessionPayload on AvailabilitySessionPayload {
  errors {
    code
    message
  }
}`);
export const RemoveItemAvailabilityPhotoDocument = new TypedDocumentString(`
    mutation RemoveItemAvailabilityPhoto($input: RemoveItemAvailabilityPhotoInput!) {
  removeItemAvailabilityPhoto(input: $input) {
    photos {
      ...ItemAvailabilityPhoto
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemAvailabilityPhoto on ItemAvailabilityPhotoData {
  photoId
  photoUrl
  recordedAt
  isPrimary
}`);
export const SetItemAvailabilityPhotoPrimaryDocument = new TypedDocumentString(`
    mutation SetItemAvailabilityPhotoPrimary($input: SetItemAvailabilityPhotoPrimaryInput!) {
  setItemAvailabilityPhotoPrimary(input: $input) {
    photos {
      ...ItemAvailabilityPhoto
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemAvailabilityPhoto on ItemAvailabilityPhotoData {
  photoId
  photoUrl
  recordedAt
  isPrimary
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AttachAvailabilitySessionPhoto: build.mutation<AttachAvailabilitySessionPhotoMutation, AttachAvailabilitySessionPhotoMutationVariables>({
      query: (variables) => ({ document: AttachAvailabilitySessionPhotoDocument, variables })
    }),
    RemoveItemAvailabilityPhoto: build.mutation<RemoveItemAvailabilityPhotoMutation, RemoveItemAvailabilityPhotoMutationVariables>({
      query: (variables) => ({ document: RemoveItemAvailabilityPhotoDocument, variables })
    }),
    SetItemAvailabilityPhotoPrimary: build.mutation<SetItemAvailabilityPhotoPrimaryMutation, SetItemAvailabilityPhotoPrimaryMutationVariables>({
      query: (variables) => ({ document: SetItemAvailabilityPhotoPrimaryDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAttachAvailabilitySessionPhotoMutation, useRemoveItemAvailabilityPhotoMutation, useSetItemAvailabilityPhotoPrimaryMutation } = injectedRtkApi;
